import { styled, Theme } from '@material-ui/core';

export const EmptyContentWrapper = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '30px',
  height: '100%',
  width: '100%',
}));

export const StyledEmptyMessage = styled('div')<Theme>(({ theme }) => ({
  fontFamily: theme.config.primaryFontFamily,
  fontSize: '3rem',
  fontWeight: 400,
  color: theme.palette.grey['500'],
  textAlign: 'center',
}));
